import { useTranslation } from "react-i18next";
import PageHero from "@/components/PageHero";
import WaitlistCTA from "@/components/home/WaitlistCTA";
import SEO from "@/components/SEO";

export default function Waitlist() {
  const { t } = useTranslation();
  return (
    <>
      <SEO
        slug="waitlist"
        title="Reserve your handle · Waitlist — Instantxfer CashApp"
        description="Join the private beta. Founder 100 members get lifetime 0.5% pricing, priority payout limits, and first pick of scan-to-pay handles."
      />
      <PageHero
        eyebrow={t("pageHero.waitlist.eyebrow")}
        title={t("pageHero.waitlist.title")}
        italic={t("pageHero.waitlist.italic")}
        body={t("pageHero.waitlist.body")}
        testId="waitlist-page-hero"
      />
      <WaitlistCTA />
    </>
  );
}
